import { useState, useContext, useEffect } from "react";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import { isInt } from "validator";
import PermissionGate from "../layout/PermissionGate";

const DriverSharing = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [_, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const fetchSetting = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}settings/get?key=driver-sharing`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.code === 1) {
        const value = Number(res?.data?.data?.value ?? 0);
        setData({
          key: "driver-sharing",
          value: Number.isInteger(value) ? value : 0,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSetting = async () => {
    const value = Number(data?.value);

    if (!Number.isInteger(value) || value < 0 || value > 100) {
      setError("Please enter a valid number (0–100)");
      return;
    }

    setError("");
    setIsUpdating(true);

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_API_ENDPOINT}settings/patch?key=driver-sharing`,
        { key: "driver-sharing", value },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setAlertConfig({
        show: true,
        message: res.data.message,
        type: res.data.code === 1 ? "success" : "danger",
      });
    } catch (err) {
      console.error(err);
      setAlertConfig({
        show: true,
        message: "Something went wrong",
        type: "danger",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    fetchSetting();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Driver Sharing
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <form autoComplete="off" id="updateSettingsForm">
                  {/* Start:Revenue Sharing */}
                  <div className="row g-5 g-lg-10 mb-5">
                    {/*begin::Card*/}
                    <PermissionGate
                      required={`view_driver_revenue_sharing_setting`}
                    >
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Revenue Sharing</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3 fv-row">
                              <label className="form-label required">
                                Sharing
                              </label>
                              <input
                                type="text"
                                className="form-control add-driver-field"
                                placeholder="Enter driver sharing"
                                value={data?.value ?? 0}
                                onChange={(e) => {
                                  setData({
                                    key: "driver-sharing",
                                    value: e.target.value,
                                  });
                                  setError("");
                                }}
                              />
                              <small className="text-danger mt-2">
                                {error}
                              </small>
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                        <PermissionGate
                          required={`edit_driver_revenue_sharing_setting`}
                          fallback={<></>}
                        >
                          <div className="card-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={updateSetting}
                              disabled={isUpdating}
                              style={{ minWidth: "160px" }}
                            >
                              {isUpdating ? (
                                <>
                                  Please wait...
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </>
                              ) : (
                                "Update Setting"
                              )}
                            </button>
                          </div>
                        </PermissionGate>
                      </div>
                    </PermissionGate>
                    {/*end::Card*/}
                  </div>
                  {/* End:Revenue Sharing */}
                </form>
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default DriverSharing;
